export default __webpack_public_path__ + "static/media/jay.488c4b45.jpg";